import axios from "axios";
import Globais, { validateToken } from "../components/Globais";



export const listarTiposPorCategoriaService = async (categoriaId: number) => {
  const Token = validateToken();
  if (!Token) return [];

  const URL = `${Globais.DOMINIOBACK}/tipos-mensagens/categoria/${categoriaId}`;
  try {
    const response = await axios.get(URL, {
      headers: { Authorization: Token.AuthStr },
    });

    return response.data.map((t: any) => ({
      key: t.id,
      id: t.id,
      nome: t.nome,
      descricao: t.descricao,
      tituloPadrao: t.tituloPadrao,
      conteudoPadrao: t.conteudoPadrao,
      active: t.active,
      linkPadrao: t.linkPadrao,
      canal: t.canal,
    }));
  } catch (error) {
    console.error(error);
    return [];
  }
};

export const criarTipoMensagemService = async (dados: any) => {
  const Token = validateToken();
  if (!Token) return null;

  const URL = `${Globais.DOMINIOBACK}/tipos-mensagens`;
  return axios.post(URL, dados, {
    headers: { Authorization: Token.AuthStr },
  });
};

export const atualizarTipoMensagemService = async (id: number, dados: any) => {
  const Token = validateToken();
  if (!Token) return null;

  const URL = `${Globais.DOMINIOBACK}/tipos-mensagens/${id}`;
  return axios.put(URL, dados, {
    headers: { Authorization: Token.AuthStr },
  });
};
